import { Paths } from '@/routes/paths'
import { useParams, useSearch } from '@tanstack/react-router'
import { AccountDetails } from './AccountDetails'
import { AccountsManagement } from './AccountsManagement'
import { AccountsMenu } from './AccountsMenu'
import { CashBoxMovements } from './CashBoxMovements'
import { MainAccountDetails } from './MainAccountDetails'

export const AccountsCnt = () => {
  const params = useParams({ strict: false }) as { accountId?: string, userId?: string }
  
  if (location.href.includes(Paths.Management.CashBox)) {
    if (params.userId) {
      return <CashBoxMovements userId={params.userId} />
    }
    return <AccountsMenu />
  }

  const isMainAccountsRoute = location.href.includes(Paths.Management.MainAccounts) || location.href.includes(Paths.Management.CollectorAccounts)
  if (params.accountId) {
    return <AccountDetails />
  }
  else if (isMainAccountsRoute) {
    return <MainAccountDetails />
  }

  return <AccountsManagement />
}
